import { useEffect, useRef, useState } from 'react'
import AnthropicLogo from '@/assets/image/home/anthropic_logo.png'
import './index.scss'

const Introduce = () => {
  const introduceRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const current = introduceRef.current

    if (!current) return undefined

    if (!('IntersectionObserver' in window)) {
      setIsVisible(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.24, rootMargin: '0px 0px -12% 0px' }
    )

    observer.observe(current)

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={introduceRef} className={`introduce${isVisible ? ' introduce--visible' : ''}`}>
      <div className="introduce-content">
        A control stack is emerging across autonomous systems. At the model layer: programs like <img className="introduce-logo" src={AnthropicLogo} alt="Anthropic" />'s Cyber Verification Program, which Vishwa is part of. At the execution layer: Vishwa - capital moves only within enforced constraints.
      </div>
    </div>
  )
}

export default Introduce
